import { motion } from "framer-motion";
import { PROFILE, SECTIONS } from "../../data/content";

const line = {
  hidden: { y: "100%" },
  show: { y: "0%" },
};

export default function Hero() {
  const s = SECTIONS[0];
  return (
    <section
      id={s.id}
      style={{ minHeight: `${s.weight * 100}vh` }}
      className="relative flex items-center px-6 md:px-12 lg:px-24"
      data-testid="section-hero"
    >
      <div className="pointer-events-none relative z-10 max-w-4xl">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4, duration: 0.6 }}
          className="mb-6 font-mono text-xs tracking-[0.4em] text-[#01FFFF]"
        >
          {s.number} — SIGNAL ONLINE
        </motion.p>

        <div className="overflow-hidden">
          <motion.h1
            variants={line}
            initial="hidden"
            animate="show"
            transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="font-heading text-5xl sm:text-6xl lg:text-8xl font-black uppercase leading-none tracking-tighter text-[#E0E6ED]"
            data-testid="hero-title"
          >
            {PROFILE.handle}
          </motion.h1>
        </div>

        <div className="mt-4 overflow-hidden">
          <motion.p
            variants={line}
            initial="hidden"
            animate="show"
            transition={{ duration: 0.9, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="font-mono text-lg sm:text-2xl text-[#01FFFF]"
          >
            {PROFILE.tagline}
          </motion.p>
        </div>

        <div className="mt-2 overflow-hidden">
          <motion.p
            variants={line}
            initial="hidden"
            animate="show"
            transition={{ duration: 0.9, delay: 0.55, ease: [0.16, 1, 0.3, 1] }}
            className="font-mono text-sm sm:text-base text-[#8A9AAB]"
          >
            {PROFILE.subTagline}
          </motion.p>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.0, duration: 0.8 }}
          className="mt-10 font-mono text-xs tracking-[0.3em] text-[#8A9AAB] animate-pulse"
        >
          ↓ SCROLL TO INITIATE JOURNEY
        </motion.p>
      </div>
    </section>
  );
}
